import { Link } from 'react-router-dom';

export default function GalleryNavbar() {
  return (
    <nav className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center space-x-3 cursor-pointer">
            <span className="text-xl font-light tracking-wider text-gray-900">
              <span className="font-bold">P</span>.collective
            </span>
          </Link>

          <div className="hidden lg:flex items-center space-x-10">
            <Link
              to="/"
              className="text-sm tracking-widest text-gray-700 hover:text-gray-900 transition-colors cursor-pointer"
            >
              홈
            </Link>
            <Link
              to="/gallery"
              className="text-sm tracking-widest text-[#D97757] font-semibold transition-colors cursor-pointer"
            >
              갤러리
            </Link>
          </div>

          <a
            href="https://form.naver.com/response/XAc4kYKR-2Wg14KJ-ilzcQ"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="hidden lg:block px-6 py-3 bg-[#D97757] text-white text-sm tracking-wide rounded-full hover:bg-[#C86647] transition-all hover:shadow-lg whitespace-nowrap cursor-pointer"
          >
            상담 예약하기
          </a>
        </div>
      </div>
    </nav>
  );
}
